import _Link from "./_Link";

export default _Link;
